<div style="padding: 5%;">
  <div class=voucher_header>Create New Voucher</div>
  <div > 
    <div>
      <mat-label style="font-family: var(--font);padding: 0px 5px;">Voucher Code</mat-label>
      <mat-form-field appearance="fill" class="voucher-field">
        <input matInput [value]="voucherCode" disabled />
      </mat-form-field>
    </div>
  <div>
    <mat-label  style="font-family: var(--font);padding: 0px 5px;">Voucher Value</mat-label>
    <mat-form-field appearance="fill" class="voucher-field">
      <input matInput [(ngModel)]="voucherValue" type="number" placeholder="Enter value" />
    </mat-form-field>
  </div>
   
    <div style="padding: 0px;">
      <button class="onclick"(click)="onNoClick()">CANCEL</button>
      <button class="onclick"(click)="createVoucher()">{{context}}</button>
    </div>
  </div>  
</div>
